import { render, staticRenderFns } from "./DobInput.vue?vue&type=template&id=01c09301&lang=pug"
import script from "./DobInput.vue?vue&type=script&lang=js"
export * from "./DobInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports